import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import useReveal from '../../hooks/useReveal';

/**
 * Closing call to action. Deep-blue panel with a soft aurora and a faint grid -
 * it echoes the hero so the page ends where it began, but inverted.
 */
const CTASection = () => {
  const ref = useReveal();

  return (
    <section ref={ref} className="section">
      <div
        className="reveal relative overflow-hidden rounded-[32px] px-6 py-16 text-center sm:px-12 sm:py-20"
        style={{
          background:
            'linear-gradient(140deg, var(--tenses-blue-deep) 0%, var(--tenses-blue-dark) 45%, var(--tenses-blue) 100%)'
        }}
      >
        {/* Aurora wash */}
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-0"
          style={{
            background:
              'radial-gradient(42% 55% at 18% 12%, rgba(143,236,120,0.18) 0%, transparent 62%), radial-gradient(46% 58% at 84% 82%, rgba(120,175,235,0.26) 0%, transparent 64%)'
          }}
        />
        {/* Grid, faded at the edges */}
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-0"
          style={{
            backgroundImage:
              'linear-gradient(rgba(255,255,255,0.06) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.06) 1px, transparent 1px)',
            backgroundSize: '54px 54px',
            maskImage: 'radial-gradient(ellipse 70% 70% at 50% 50%, #000 25%, transparent 75%)',
            WebkitMaskImage: 'radial-gradient(ellipse 70% 70% at 50% 50%, #000 25%, transparent 75%)'
          }}
        />

        <div className="relative z-10 mx-auto max-w-[640px]">
          <h2
            className="heading-2"
            style={{ color: '#fff', fontSize: 'clamp(2rem, 4.4vw, 3.2rem)' }}
          >
            Find out where your
            <br />
            English actually stands
          </h2>

          <p className="body-large mt-5" style={{ color: 'rgba(255,255,255,0.72)' }}>
            Take a module, hear the feedback, and see your first accuracy score today.
          </p>

          <div className="mt-9 flex flex-col justify-center gap-3 sm:flex-row">
            <a
              href="https://app.tenses.ai"
              className="inline-flex min-h-[50px] items-center justify-center gap-2 rounded-full bg-white px-8 text-[0.975rem] font-semibold transition-transform duration-200 hover:-translate-y-0.5"
              style={{ color: 'var(--tenses-blue-dark)', boxShadow: '0 10px 30px rgba(0,0,0,0.22)' }}
            >
              Get started
              <ArrowRight className="h-4 w-4" />
            </a>
            <Link
              to="/pricing"
              className="inline-flex min-h-[50px] items-center justify-center rounded-full px-7 text-[0.975rem] font-medium transition-colors"
              style={{
                color: '#fff',
                background: 'rgba(255,255,255,0.1)',
                border: '1px solid rgba(255,255,255,0.22)'
              }}
            >
              See pricing
            </Link>
          </div>

          <p className="mt-6 text-[0.85rem]" style={{ color: 'rgba(255,255,255,0.5)' }}>
            Instant access · Plans from ₹1,500
          </p>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
